export const config = {
  roles: import.meta.env.VITE_ROLES?.split(",") || ["devops", "default"],
  platforms: import.meta.env.VITE_PLATFORMS?.split(",") || ["aws", "azkv", "vault"],
  secretStore: JSON.parse(import.meta.env.VITE_ACCOUNTS_OBJECT || '{"kuda-devops-eks":[["aws","eu-west-2"]]}'),
  projects: JSON.parse(import.meta.env.VITE_APP_PROJECTS || '[]'),
  environments: JSON.parse(import.meta.env.VITE_ENVIRONMENTS || '[]'),
  secretTypes: JSON.parse(import.meta.env.VITE_SECRET_TYPE || '[]'),
  apiAccess: import.meta.env.VITE_API_ACCESS || "api://default/.default",

  // Vault engines (by vaultId/mount name) that store secrets under nested
  // <environment>/<team>/<name> paths instead of a flat <name> namespace.
  // New secrets created against one of these have their path derived from
  // the Environment/Team fields; anything not listed here keeps the
  // original flat behavior untouched.
  vaultNestedPathEngines: JSON.parse(import.meta.env.VITE_VAULT_NESTED_PATH_ENGINES || '["secret","secrets-prod"]'),

  rbac: {
    adminRoles:      ["devops", "default"],
    elevatedRoles:   ["technical_lead", "senior_developer"],
    prodAccessRoles: ["devops", "technical_lead", "senior_developer"],
    projectTeams: [
      "everyday-banking",
      "payments-and-cards",
      "kuda-internaltools",
      "business-banking",
      "kuda-cards",
      "kuda-channels",
      "kuda-core",
      "kuda-credit",
      "kuda-devops",
      "kuda-growth",
      "kuda-nerve",
      "kuda-web",
      "onboarding-and-identity",
      "kuda-remittance",
      "kuda-discovery",
      "shared-services",
    ],
  },

  prodAccessRoles: ["devops", "technical_lead", "senior_developer"],

  awsProfiles: {
    "profile-a": {
      account: "aws-test-acct",
      name: "Profile A (eu-west-2)",
      region: "eu-west-2",
      description: "Production Account - London",
    },
    "profile-b": {
      account: "aws-profile-b",
      name: "Profile B (eu-west-3)",
      region: "eu-west-3",
      description: "Test Account - Paris",
    },
    "profile-dev": {
      account: "kuda-dev",
      name: "Dev (eu-west-2)",
      region: "eu-west-2",
      description: "Dev Account - OIDC",
    },
  },
};

/**
 * Returns all providers for a given cluster key.
 * Always returns an array of { platformName, vaultId } objects.
 * Works for both old flat format ["aws","eu-west-2"] and new
 * array-of-arrays format [["aws","eu-west-2"], ["vault","secrets"]].
 */
export function getClusterProviders(clusterKey) {
  const entry = config.secretStore[clusterKey];
  if (!entry || !Array.isArray(entry)) return [];

  // New format: array of arrays  [["aws","eu-west-2"], ...]
  if (Array.isArray(entry[0])) {
    return entry.map(([platformName, vaultId]) => ({ platformName, vaultId }));
  }

  // Legacy flat format: ["aws","eu-west-2"]
  return [{ platformName: entry[0], vaultId: entry[1] }];
}